import * as yup from "yup";

export type FormValues = yup.Asserts<typeof validationSchema>;

export const validationSchema = yup.object({
  name: yup.string().required(),
  tag: yup.string().required(),
  description: yup.string().required(),
});
